import { mapGetters, mapActions } from 'vuex'

import { getDateNowUnix } from '@/utils/dateHelpers'

import TableList from '@/components/TableList/index'

export default {
  name: 'leaderboards-continent',
  components: {
    TableList
  },
  data: () => ({
    userList: null,
    headerArr: ['Rank', 'Name', 'Pts', 'Avg.', 'Total', '']
  }),
  methods: {
    ...mapActions('leaderboards', {
      fetchLeaderboardsContinentAction: 'FETCH_LEADERBOARDS_CONTINENT'
    }),
    startRound(startTime) {
      const dateNow = getDateNowUnix()
      return dateNow >= startTime
    },
    rankDrawCheck(allUsers, rankNo) {
      const drawLength = allUsers.filter(user => user.rank === rankNo)
      return drawLength.length > 1
    }
  },
  computed: {
    ...mapGetters('leaderboards', {
      leaderboardsContinent: 'LEADERBOARDS_CONTINENT_RESPONSE'
    }),
    ...mapGetters('auth', {
      userObj: 'USER_OBJ'
    })
  },
  activated() {
    this.fetchLeaderboardsContinentAction().then(() => {
      const {
        success,
        data,
        currentRoundStart,
        previousRound
      } = this.leaderboardsContinent
      const averageIndex = this.headerArr.findIndex(item => item === 'Avg.')
      const prevRound = previousRound
      const pointsIndex = this.headerArr.findIndex(item => item === 'Pts')
      const startRound = this.startRound(
        parseInt(currentRoundStart.event_timestamp)
      )
      if (prevRound) {
        this.headerArr[averageIndex] = `Avg.(R${prevRound})`
        this.headerArr[pointsIndex] = `R${
          startRound ? prevRound + 1 : prevRound
        } Pts`
      } else {
        this.headerArr[averageIndex] = `Avg.(R1)`
        this.headerArr[pointsIndex] = `R1 Pts`
      }
      if (success) {
        this.userList = data.currentRank.map(user => {
          const { id, username, avatar, total, roundCount, rank } = user
          const prevRankIndex = data.prevRank
            ? data.prevRank.findIndex(item => item.id === id)
            : data.currentRank

          const parsedRoundCount = parseInt(roundCount) - 1
          const totalPoints = total || 0
          const startRound = this.startRound(
            parseInt(currentRoundStart.event_timestamp)
          )
          const points =
            !startRound && data.prevRank
              ? data.prevRank[prevRankIndex].lastWeekTotalPoints
              : prevRankIndex >= 0
              ? total - data.prevRank[prevRankIndex].total
              : totalPoints
          const rankDraw = this.rankDrawCheck(data.currentRank, rank)

          return {
            id,
            rank,
            name: `${username}`,
            avatar,
            points,
            average:
              parsedRoundCount > 0 && prevRankIndex >= 0
                ? data.prevRank[prevRankIndex].total / parsedRoundCount
                : 0,
            total: totalPoints,
            rankStatus:
              prevRankIndex >= 0 ? data.prevRank[prevRankIndex].rank - rank : 0,
            rankDraw
          }
        })
      }
    })
  },
  deactivated() {
    this.userList = null
  }
}
